const Accounts: React.FC = () => {
  return <div>Accounts</div>
}

export default Accounts
